import { render, staticRenderFns } from "./MyQuizzesEditGame.vue?vue&type=template&id=4362a286&scoped=true&"
import script from "./MyQuizzesEditGame.vue?vue&type=script&lang=js&"
export * from "./MyQuizzesEditGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4362a286",
  null
  
)

export default component.exports